import { colors } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    header: (isBig = false) => ({
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      flexDirection: isBig ? 'column-reverse' : 'row',
      alignItems: 'start',
      gap: isBig ? 1.5 : 1,
      overflow: 'hidden',

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        gap: 1,
      },
    }),
    headerText: {
      display: 'flex',
      alignItems: 'center',
      columnGap: 1,
      color: colors.white,
      width: '100%',
    },
    text: {
      fontSize: 32,
      fontFamily: 'var(--primary-font-bold)',
      lineHeight: 1,
      minWidth: 0,
      letterSpacing: '-0.04em',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 24,
      },
    },
    actions: (isOneAction = true) => ({
      display: 'flex',
      justifyContent: isOneAction ? 'end' : 'space-between',
      width: '100%',
    }),
    buttonIcon: {
      cursor: 'pointer',
      padding: 0,

      '& svg': {
        height: '12px',
        width: '12px',
      },
    },
    closeIcon: {
      fontSize: 12,
      color: colors.grey_200,
    },
    headerMobile: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    headerTextMobile: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingRight: '10px',
    },
    rightActionsMobile: {
      display: 'flex',
    },
    findMobile: {
      display: 'flex',
      marginRight: '30px',
    },
    findTextMobile: {
      color: colors.grey_300,
      whiteSpace: 'nowrap',
      fontSize: '14px',
    },
    findIconMobile: {
      marginRight: '5px',
      fill: colors.grey_300,
      height: '22px',
    },
    buttonIconMobile: {
      cursor: 'pointer',
      padding: '0px 6px',
      height: '16px',
      marginTop: '3px',
    },
    closeIconMobile: {
      fontSize: 16,
    },
    textMobile: (hasBackAction: boolean) => ({
      fontSize: 22,
      fontFamily: 'var(--primary-font-bold)',
      lineHeight: 1,
      letterSpacing: '-0.04em',
      marginLeft: hasBackAction ? '10px' : 0,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
  };
};
